<template>
  <div class="customer-service-modal" v-if="visible">
    <div class="modal-content">
      <div class="modal-header">
        <h3>添加企业微信</h3>
        <button class="close-btn" @click="close">×</button>
      </div>
      <div class="modal-body">
        <p>为您提供1对1系统解答</p>
        <div class="qr-code">
          <img src="../assets/kefu.png" alt="企业微信二维码" />
        </div>
        <div class="contact-info">
          <p>系统咨询: 400-688-5235</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerService',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.customer-service-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-content {
  background-color: #fff;
  border-radius: 8px;
  width: 360px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f3f4;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-body {
  padding: 24px;
  text-align: center;
}

.modal-body p {
  margin: 0 0 16px;
  color: #4b5563;
  font-size: 15px;
}

.qr-code {
  margin: 16px 0;
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 8px;
}

.qr-code img {
  max-width: 200px;
  height: auto;
}

.contact-info {
  margin-top: 16px;
  color: #3470ff;
  font-weight: 500;
}
</style> 